import { put, select } from 'redux-saga/effects';
import constants from '../../../../core/constants';
import DateHelpers from '../../../../core/helpers/DateHelper';
import {
  findAcademicCalendar,
  findGlobalMeetingsByWeek
} from '../getScheduleUseCase/saga';
import { Types } from './actions';

export function findVirtualMeetingsByWeek(
  virtualMmeetings: any[],
  dates: Date[]
): any {
  let virtualMeetingsByWeek: any[] = [];
  const daysOfWeek = dates;
  daysOfWeek.forEach((date: Date) => {
    const meetingsByDay = virtualMmeetings.filter(
      (meet: any) =>
        DateHelpers.formatDate(meet.start) ===
        DateHelpers.formatDate(date.getTime())
    );
    virtualMeetingsByWeek = virtualMeetingsByWeek.concat(meetingsByDay);
  });
  const grouped = virtualMeetingsByWeek.reduce((r: any, x: any) => {
    const id = x.id.split('_')[0];
    const r1 = r;
    r1[id] = [
      [...(r1[id] || []), x].reduce((a) => ({
        ...a
      }))
    ];
    return r1;
  }, {});
  let accumulateVirtualMeetings: any[] = [];
  Object.keys(grouped).forEach((key: any) => {
    accumulateVirtualMeetings = accumulateVirtualMeetings.concat(grouped[key]);
  });
  return accumulateVirtualMeetings;
}

export function findModule(dateToCompare: number, modules: any[]) {
  const moduleFound = modules.find(
    (value: any) =>
      DateHelpers.isBetweenDates(
        value.startDate + constants.MIL_PERU,
        value.endDate + constants.MIL_PERU,
        dateToCompare
      ) && value.career === 'PPE'
  );
  return moduleFound;
}

export function findWeek(dateToCompare: number, weeks: any[]) {
  const weekFound = weeks.find((value: any) =>
    DateHelpers.isBetweenDates(value.start, value.end, dateToCompare)
  );
  return weekFound;
}

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.FILTER_BY_WEEK_REQUEST });
    const { dataWeek } = action;
    const { data: dataSchedule } = yield select(
      (status) => status.scheduleOnly
    );
    const { data: dataAcademicDates } = yield select(
      (state) => state.academicdates
    );
    const { data: dataActivities } = yield select((state) => state.activities);
    const { data: dataExams } = yield select((state: any) => state.exams);
    const { data: dataReinforcements } = yield select(
      (state: any) => state.reinforcements
    );

    const { period } = yield select((state: any) => state.currentPeriod);

    let academicCalendarByWeek = null;
    let scheduleByWeek = null;
    let virtualMeetingsByWeek = null;
    let currentModule = null;
    let currentWeek = null;
    if (dataAcademicDates) {
      academicCalendarByWeek = findAcademicCalendar(
        dataWeek.week,
        dataAcademicDates?.all,
        dataWeek?.selectedDate
      );
    }
    const meetingsWithProfessor = (dataSchedule?.meetings || []).map(
      (m: any) => ({
        ...m,
        professor: `${m.professor?.firstName} ${m.professor?.lastName}`
      })
    );

    const vMeetingsWithProfessor = (dataSchedule?.virtualMeetings || []).map(
      (m: any) => ({
        ...m,
        professor: `${m.professor?.firstName} ${m.professor?.lastName}`
      })
    );
    virtualMeetingsByWeek = findVirtualMeetingsByWeek(
      vMeetingsWithProfessor || [],
      dataWeek?.week || []
    );

    const allMeetings = (meetingsWithProfessor || []).concat(
      dataActivities?.subscriptions || [],
      dataReinforcements?.subscriptions || [],
      dataExams?.exams || []
    );

    scheduleByWeek = findGlobalMeetingsByWeek(
      allMeetings || [],
      dataWeek?.week || []
    );

    if (period) {
      const { modules, weeks } = period;
      currentModule = findModule(dataWeek?.selectedDate?.getTime(), modules);
      currentWeek = findWeek(dataWeek?.selectedDate?.getTime(), weeks);
    }

    const data = {
      academicCalendarByWeek,
      scheduleByWeek,
      virtualMeetingsByWeek,
      currentModule,
      currentWeek
    };
    yield put({ type: Types.FILTER_BY_WEEK_SUCCESS, data });
  } catch (error) {
    yield put({
      type: Types.FILTER_BY_WEEK_FAILURE,
      error: 'Ocurrió un error'
    });
    throw error;
  }
}
